module.exports = __webpack_public_path__ + "static/slider_6-6cc0cdbeaba8fe2a8263d8b4913025d3.jpg";